import React, { useState, useContext } from 'react';
import CourseTable from '../components/exl/CourseTable'
import ErrorPage from './error';
import { DataContext } from '../store';
import Toasts from '../components/crm/shared/Toasts';
import ExlToasts from '../components/crm/shared/ExlToasts';

const ExlCourses = () => {
    const {
        store: { user },
    } = useContext(DataContext);

    const [error] = useState(null);
    return (error || !user || !(user.isExlAdmin || user.isAdmin || user.isExlUser)) ? (
        <ErrorPage error={error} />
    ) : (
        <>
            <CourseTable />
            <ExlToasts />
        </>
    );
};

export default ExlCourses;

